export const columns = [
    {
        title:'年份',
        dataIndex:"year",
        key:"year"
    },
    {
        title:'交通运输排放量',
        dataIndex:"transportation",
        key:"transportation"
    },
    {
        title:'工业排放量',
        dataIndex:"industrial",
        key:"industrial"
    },
    {
        title:'农业排放量',
        dataIndex:"agriculture",
        key:"agriculture"
    },
    {
        title:'其他行业排放量',
        dataIndex:"otherIndustries",
        key:"otherIndustries"
    },
    {
        title:'汇总量',
        dataIndex:"sum",
        key:"sum",
        slots:"sum"
    },
    {
        title:'交通排放占比',
        dataIndex:"transportationScale",
        key:"transportationScale",
        slots:"transportationScale",
    },
    {
        title:'工业排放占比',
        dataIndex:"industrialScale",
        key:"industrialScale",
        slots:"industrialScale",
    },
    {
        title:'农业排放占比',
        dataIndex:"agricultureScale",
        key:"agricultureScale",
        slots:"agricultureScale",
    },
    {
        title:'其他行业占比',
        dataIndex:"otherIndustriesScale",
        key:"otherIndustriesScale",
        slots:"otherIndustrieScales"
    },
    {
        title:'操作人',
        dataIndex:"revisorName",
        key:"revisorName"
    },
    {
        title:'操作时间',
        dataIndex:"updateTime",
        key:"updateTime"
    },
    {
        title: "操作",
        slots:'actions',
        width:180,
        fixed:'right'
    },
]
export const columns1 = [
    {
        title:'年份',
        dataIndex:"year",
        key:"year"
    },
    {
        title:'茶叶咖啡种植量',
        dataIndex:"teaCoffee",
        key:"teaCoffee"
    },
    {
        title:'沼气粪肥量',
        dataIndex:"biogasManure",
        key:"biogasManure"
    },
    {
        title:'人工林',
        dataIndex:"plantedForest",
        key:"plantedForest"
    },
    {
        title:'天然林',
        dataIndex:"naturalForest",
        key:"naturalForest"
    },
    {
        title:'水电',
        dataIndex:"hydropower",
        key:"hydropower"
    },
    {
        title:'汇总量',
        dataIndex:"sum",
        key:"sum",
        slots:"sum"
    },
    // {
    //     title:'茶叶咖啡种植量占比',
    //     dataIndex:"teaCoffeeScales",
    //     key:"teaCoffeeScales",
    //     slots:"teaCoffeeScales"
    // },
    {
        title:'沼气粪肥量',
        dataIndex:"biogasManureScales",
        key:"biogasManureScales",
        slots:"biogasManureScales",
    },
    {
        title:'人工林占比',
        dataIndex:"plantedForestScales",
        key:"plantedForestScales",
        slots:"plantedForestScales",
    },
    {
        title:'天然林占比',
        dataIndex:"naturalForestScales",
        key:"naturalForestScales",
        slots:"naturalForestScales"
    },
    {
        title:'水电占比',
        dataIndex:"hydropowerScales",
        key:"hydropowerScales",
        slots:"hydropowerScales",
    },
    {
        title:'操作人',
        dataIndex:"revisorName",
        key:"revisorName"
    },
    {
        title:'操作时间',
        dataIndex:"updateTime",
        key:"updateTime"
    },
    {
        title: "操作",
        slots:'actions',
        width:180,
        fixed:'right'
    },
]
export const columns2 = [
    {
        title:'年份',
        dataIndex:"year",
        key:"year"
    },
    {
        title:'沼气粪肥量',
        dataIndex:"biogasManure",
        key:"biogasManure"
    },
    {
        title:'人工林',
        dataIndex:"plantedForest",
        key:"plantedForest"
    },
    {
        title:'水电',
        dataIndex:"hydropower",
        key:"hydropower"
    },
    {
        title:'天然林',
        dataIndex:"teaCoffee",
        key:"teaCoffee"
    },
    {
        title:'汇总量',
        dataIndex:"sum",
        key:"sum",
        slots:"sum"
    },
    {
        title:'沼气粪肥量占比',
        dataIndex:"biogasManureScales",
        key:"biogasManureScales",
        slots:"biogasManureScales",
    },
    {
        title:'人工林占比',
        dataIndex:"plantedForestScales",
        key:"plantedForestScales",
        slots:"plantedForestScales",
    },
    {
        title:'水电占比',
        dataIndex:"hydropowerScales",
        key:"hydropowerScales",
        slots:"hydropowerScales",
    },
    {
        title:'天然林占比',
        dataIndex:"teaCoffeeScales",
        key:"teaCoffeeScales",
        slots:"teaCoffeeScales"
    },
    {
        title:'操作人',
        dataIndex:"revisorName",
        key:"revisorName"
    },
    {
        title:'操作时间',
        dataIndex:"updateTime",
        key:"updateTime"
    },
    {
        title: "操作",
        slots:'actions',
        width:180,
        fixed:'right'
    },
]
export const columns3 = [
    {
        title:'年份',
        dataIndex:"year",
        key:"year"
    },
    {
        title:'大工业',
        dataIndex:"greatIndustry",
        key:"greatIndustry"
    },
    {
        title:'非普工业',
        dataIndex:"generalIndustrial",
        key:"generalIndustrial"
    },
    {
        title:'商业',
        dataIndex:"business",
        key:"business"
    },
    {
        title:'居民生活',
        dataIndex:"residentsLiving",
        key:"residentsLiving"
    },
    {
        title:'养殖业',
        dataIndex:"aquaculture",
        key:"aquaculture"
    },
    {
        title:'交通运输业',
        dataIndex:"transportationIndustry",
        key:"transportationIndustry"
    },
    {
        title:'非居民照明',
        dataIndex:"residentPhotograph",
        key:"residentPhotograph"
    },
    {
        title:'农业生产',
        dataIndex:"agriculturalProduction",
        key:"agriculturalProduction"
    },
    {
        title:'农业排灌',
        dataIndex:"agriculturalDrainage",
        key:"agriculturalDrainage"
    },
    {
        title:'操作人',
        dataIndex:"revisorName",
        key:"revisorName"
    },
    {
        title:'操作时间',
        dataIndex:"updateTime",
        key:"updateTime"
    },
    {
        title: "操作",
        slots:'actions',
        width:180,
        fixed:'right'
    },
]
export const columns4 = [
    {
        title:'年份',
        dataIndex:"year",
        key:"year"
    },
    {
        title:'工业生产',
        dataIndex:"industrialProduction",
        key:"industrialProduction"
    },
    {
        title:'农业生产',
        dataIndex:"agriculturalProduction",
        key:"agriculturalProduction"
    },
    {
        title:'交通运输',
        dataIndex:"transportation",
        key:"transportation"
    },
    {
        title:'其他行业',
        dataIndex:"otherIndustries",
        key:"otherIndustries"
    },
    {
        title:'操作人',
        dataIndex:"revisorName",
        key:"revisorName"
    },
    {
        title:'操作时间',
        dataIndex:"updateTime",
        key:"updateTime"
    },
    {
        title: "操作",
        slots:'actions',
        width:180,
        fixed:'right'
    },
]
export const columns5 = [
    {
        title:'年份',
        dataIndex:"year",
        key:"year"
    },
    {
        title:'碳排放总量',
        dataIndex:"totalCarbonEmission",
        key:"totalCarbonEmission"
    },
    {
        title:'碳吸收总量（包括天然林）',
        dataIndex:"totalCarbonAbsorption",
        key:"totalCarbonAbsorption"
    },
    {
        title:'可供抵消的碳吸收总量',
        dataIndex:"offsetTotalCarbonAbsorption",
        key:"offsetTotalCarbonAbsorption"
    },
    {
        title:'操作人',
        dataIndex:"revisorName",
        key:"revisorName"
    },
    {
        title:'操作时间',
        dataIndex:"updateTime",
        key:"updateTime"
    },
    {
        title: "操作",
        slots:'actions',
        width:180,
        fixed:'right'
    },
]